import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Typography,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material';

function SipDomains() {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [newDomain, setNewDomain] = useState({
    domainName: '',
    friendlyName: ''
  });

  const fetchDomains = async () => {
    try {
      const response = await axios.get('/twilio/sip-domains');
      setDomains(response.data.domains);
      setLoading(false);
    } catch (err) {
      setError('Failed to load SIP domains');
      setLoading(false);
      console.error('SIP domains fetch error:', err);
    }
  };

  useEffect(() => {
    fetchDomains();
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewDomain({ domainName: '', friendlyName: '' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewDomain(prev => ({ ...prev, [name]: value }));
  };

  const handleCreateDomain = async () => {
    try {
      await axios.post('/twilio/create-sip-domain', newDomain);
      fetchDomains();
      handleCloseDialog();
    } catch (err) {
      console.error('Error creating SIP domain:', err);
      alert('Failed to create SIP domain. Please check console for details.');
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">SIP Domains</Typography>
        <Button variant="contained" color="primary" onClick={handleOpenDialog}>
          Create Domain
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sip domains table">
          <TableHead>
            <TableRow>
              <TableCell>SID</TableCell>
              <TableCell>Domain Name</TableCell>
              <TableCell>Friendly Name</TableCell>
              <TableCell>Date Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {domains.map((domain) => (
              <TableRow key={domain.sid}>
                <TableCell>{domain.sid}</TableCell>
                <TableCell>{domain.domainName}</TableCell>
                <TableCell>{domain.friendlyName}</TableCell>
                <TableCell>{new Date(domain.dateCreated).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {domains.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">No SIP domains found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Create New SIP Domain</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="domainName"
            label="Domain Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newDomain.domainName}
            onChange={handleChange}
            helperText="e.g., mydomain.sip.twilio.com"
          />
          <TextField
            margin="dense"
            name="friendlyName"
            label="Friendly Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newDomain.friendlyName}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleCreateDomain} variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default SipDomains;
